import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import FilterSelect from "component/common/FilterSelect";
import { getCategoryStats } from "service/Dashboard";
import ChartLoader from "component/common/ChartLoader";

import styles from "./ProductCategoryStats.module.scss";
import { Toast } from "utils/toast";

const ProductCategoryStats = () => {
  let [category, setCategory] = useState({
    series: [],
    options: {
      chart: {
        type: "donut",
        redrawOnWindowResize: true,
        redrawOnParentResize: true,
      },
      legend: {
        show: true,
        showForSingleSeries: false,
        showForNullSeries: true,
        showForZeroSeries: true,
        position: "right",
        horizontalAlign: "center",
        floating: false,
        fontSize: "14px",
        fontFamily: "Helvetica, Arial",
        fontWeight: 600,
        formatter: undefined,
        inverseOrder: false,
        width: undefined,
        height: undefined,
        tooltipHoverFormatter: undefined,
        customLegendItems: [],
        offsetX: -30,
        offsetY: 10,
        labels: {
          colors: "#151522",
          useSeriesColors: false,
        },
        markers: {
          width: 20,
          height: 20,
          strokeWidth: 0,
          strokeColor: "#fff",
          radius: 12,
          offsetX: "-10px",
          offsetY: "4px",
        },
        itemMargin: {
          horizontal: 5,
          vertical: 5,
        },
        onItemClick: {
          toggleDataSeries: false,
        },
        onItemHover: {
          highlightDataSeries: false,
        },
      },
      colors: [
        "#3C5877",
        "#81A794",
        "#96C0FF",
        "#979797",
        "#C9E3D6",
        "#DDDDDD",
        "#E2CE63",
      ],
      labels: [],
      dataLabels: {
        enabled: false,
      },
    },
  });

  let [loading, setLoading] = useState(true);

  let [year, setYear] = useState(2021);

  const yearOptions = [2021];

  useEffect(() => {
    setLoading(true);
    getCategory();
  }, [year]);

  const getCategory = async () => {
    try {
      let response = await getCategoryStats({ year: year });
      if (response.status == 200) {
        let label = [];
        let count = [];
        response.data.data.map((list) => {
          label.push(list.categoryName);
          count.push(list.total);
          return null;
        });
        let categoryStats = category;
        categoryStats.series = count;
        categoryStats.options.labels = label;
        setCategory(categoryStats);
        setLoading(false);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  return (
    <div className="col-md-6 position-relative">
      <div className={styles.category_chart}>
        <div className={styles.category_chart_title}>
          <b>Product Category Stats</b>
          <div style={{ width: "100px" }}>
            <FilterSelect
              options={yearOptions}
              value={year}
              onChange={(e) => setYear(e.value)}
            />
          </div>
        </div>
        {loading ? (
          <ChartLoader />
        ) : (
          <ReactApexChart
            options={category.options}
            series={category.series}
            type="donut"
            height={300}
          />
        )}
      </div>
    </div>
  );
};

export default ProductCategoryStats;
